const validateDomain = (domain) => {
  const domainRegex = /^[^\s@]+\.[^\s@]+$/;
  return domainRegex.test(domain);
};

export default validateDomain;
